import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** BHP field method — clamp ammeter on motor leads, nameplate plate, scaled output. */
export function DiagramBrakeHorsepower() {
  return (
    <DiagramCanvas>
      {/* 3-phase supply lines coming in */}
      {[110, 130, 150].map((yp, i) => (
        <G key={i}>
          <Line x1={20} y1={yp} x2={120} y2={yp} stroke={DT.stroke} strokeWidth="2" />
          <SvgText x={14} y={yp + 3} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="end">L{i + 1}</SvgText>
        </G>
      ))}

      {/* Clamp ammeter (encircling one phase) */}
      <Circle cx={70} cy={130} r={14} fill="none" stroke={DT.varColor} strokeWidth="1.6" />
      <Path d={`M58,128 A14,14 0 0 0 82,132`} fill="none" stroke={DT.varColor} strokeWidth="1.6" />
      <Rect x={56} y={142} width={28} height={20} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" rx="2" />
      <SvgText x={70} y={156} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">A</SvgText>

      {/* Motor body */}
      <Rect x={120} y={90} width={130} height={90} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" rx="6" />
      {/* Cooling fins */}
      {Array.from({ length: 8 }).map((_, i) => (
        <Line key={i} x1={120} y1={94 + i * 11} x2={250} y2={94 + i * 11}
          stroke={DT.stroke} strokeWidth="0.4" opacity={0.4} />
      ))}
      {/* Junction box */}
      <Rect x={140} y={82} width={28} height={12} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" />

      {/* Nameplate */}
      <Rect x={170} y={108} width={68} height={48} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" rx="2" />
      <SvgText x={204} y={121} fill={DT.desc} fontSize="7" fontFamily={DT.mono} textAnchor="middle">NAMEPLATE</SvgText>
      <SvgText x={204} y={134} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">HP</SvgText>
      <SvgText x={204} y={146} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">FLA</SvgText>

      {/* Shaft → load */}
      <Line x1={250} y1={135} x2={300} y2={135} stroke={DT.stroke} strokeWidth="5" />
      {/* Sheave */}
      <Circle cx={290} cy={135} r={12} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.4" />
      <Circle cx={290} cy={135} r={3} fill={DT.stroke} />

      {/* Output BHP gauge */}
      <Circle cx={320} cy={70} r={14} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <Line x1={320} y1={70} x2={313} y2={64} stroke={DT.varColor} strokeWidth="1.5" />
      <Circle cx={320} cy={70} r={1.5} fill={DT.varColor} />
      <SvgText x={320} y={52} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">BHP</SvgText>

      {/* Labels */}
      <LeaderLine x1={70} y1={142} x2={20} y2={205} varName="A" desc="measured amps" anchor="start" />
      <LeaderLine x1={204} y1={134} x2={150} y2={70} varName="HP·FLA" desc="from nameplate" anchor="end" />
      <LeaderLine x1={290} y1={147} x2={300} y2={205} varName="BHP" desc="HP·(A/FLA)" anchor="end" />

      <FormulaTag formula="BHP ≈ HP_nameplate · (A_meas / FLA)   (constant V, PF)" />
    </DiagramCanvas>
  );
}
